import {Injectable, signal} from '@angular/core';

export const benefitsPageStyles = ['initial', 'deferred-with-trial', 'deferred-without-trial', 'native-initial', 'native-sunk', 'native-no-trial'] as const;
export type BenefitsPageStyleOverride = typeof benefitsPageStyles[number] | null;

@Injectable({
  providedIn: 'root'
})
export class DebugService {
  public readonly benefitsPageStyleOverride = signal<BenefitsPageStyleOverride>(null);
}
